import operations from './operations';
var path = '/logs';
var logs = function (url) { return function () { return ({
    operations: operations(url + path),
}); }; };
export default logs;
